const settings = {
  brandSite: true,
  channels: [
    {
      channel: 'Social Wines EN',
      locale: 'en-US',
      languageCode: 'en',
      slugs: {
        ContentfulArticlePage: 'article',
      },
    },
  ],
  localization: {
    default: 'en-US',
    defaultLanguageCode: 'en',
  },
};

export default settings;
